export default "__VITE_ASSET__CycmSwP2__"